module.exports = __webpack_public_path__ + "static/media/tours.9afad675.jpg";